import { useEffect, useState } from "react";
import { ASSETS, LINKS } from "@/lib/brand";

const HOME_VALUE_URL = ASSETS.homeValueUrl;

const links = [
  { label: "About", href: "#about" },
  { label: "Real Estate", href: "#real-estate" },
  { label: "Create", href: "#create" },
  { label: "Contact", href: "#contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 20);
    on();
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-ivory/90 backdrop-blur border-b border-charcoal/10" : "bg-transparent"
      }`}
    >
      <div className="container-edit flex items-center justify-between py-5">
        <a href="#top" data-testid="nav-brand" className="flex items-center gap-3">
          <span className="font-serif-heading text-2xl md:text-3xl text-charcoal">Stefanie Winstan</span>
        </a>
        <nav className="hidden md:flex items-center gap-6 lg:gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-xs uppercase tracking-[0.22em] text-charcoal/70 hover:text-bronze transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href={HOME_VALUE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-cta-home-value"
          className="hidden md:inline-flex items-center bg-charcoal text-ivory ml-8 px-5 py-3 text-[10px] uppercase tracking-[0.18em] font-semibold hover:bg-bronze transition-colors max-w-[260px] leading-tight text-center"
        >
          Click here to instantly find out what your home is worth
        </a>
        <button
          type="button"
          className="md:hidden text-charcoal text-xs uppercase tracking-[0.22em]"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-menu-toggle"
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-charcoal/10 bg-ivory">
          <div className="container-edit py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.22em] text-charcoal/80"
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href={HOME_VALUE_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-cta"
              className="bg-charcoal text-ivory text-center px-6 py-3 text-[10px] uppercase tracking-[0.18em] font-semibold mt-2 leading-tight"
            >
              Click here to instantly find out what your home is worth
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
export const _navAssets = ASSETS;
export const _navLinks = LINKS;
